import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var RadioPage = function (_super) {
  __extends(RadioPage, _super);

  function RadioPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.rate = null;
    return _this;
  }

  RadioPage.prototype.handleChange = function () {
    var _a;

    var index = this.rate - 1;
    var option_id = (_a = this.options[index]) === null || _a === void 0 ? void 0 : _a.option_id;
    this.$emit('input', option_id);
  };

  __decorate([Prop({
    type: Array,
    "default": []
  })], RadioPage.prototype, "options", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], RadioPage.prototype, "value", void 0);

  RadioPage = __decorate([Component({})], RadioPage);
  return RadioPage;
}(Vue);

export default RadioPage;